import React, { Component } from 'react'
import {
  Button
} from '@blueprintjs/core';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import ClientAutocomplete from 'components/ClientAutocomplete';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';
import ServiceTypePicker from 'components/ServiceTypePicker';

@inject('store', 'userStore', 'viewStore') @observer
class ServiceAgreement extends Component {

  @observable showServiceAgreementModal = false;

  handleCloseServiceAgreementModal() {
    this.showServiceAgreementModal = false;
  }

  onSuccessServiceAgreementModal() {
    this.showServiceAgreementModal = false;
  }

  @action
  onClientSelect(client) {
    let {
      props: {
        viewStore: {
          serviceAgreementSearch,
        }
      }
    } = this;
    if (client) {
      this.props.viewStore.serviceAgreementSearch = {
        ...serviceAgreementSearch,
        where: {
          ...serviceAgreementSearch.where,
          client_id: client.id
        }
      }
    } else {
      this.props.viewStore.serviceAgreementSearch = {
        ...serviceAgreementSearch,
        where: {
          ...serviceAgreementSearch.where,
          client_id: "",
        }
      }
    }
  }

  setWhere(changes) {
    const { serviceAgreementSearch } = this.props.viewStore;
    this.props.viewStore.serviceAgreementSearch = {
      ...serviceAgreementSearch,
      where: { ...serviceAgreementSearch.where, ...changes },
    };
  }

  @action
  onServiceTypeChange(selections) {
    this.setWhere({ service_type_id: selections.map((option) => option.value) });
  }

  @action
  onTermChange(e) {
    let {
      props: {
        viewStore: {
          serviceAgreementSearch
        }
      }
    } = this;
    this.props.viewStore.serviceAgreementSearch = {
      ...serviceAgreementSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.serviceAgreementSearch.page = 1;
    viewStore.serviceAgreements();
  }

  render() {
    const {
      term,
      where
    } = this.props.viewStore.serviceAgreementSearch;
    return(
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
      >
        <ClientAutocomplete
          selectedClientId={where && where.client_id}
          onClientSelect={this.onClientSelect.bind(this)}
        />

        <ServiceTypePicker
          selectedOptions={(where && where.service_type_id) || []}
          onChange={this.onServiceTypeChange.bind(this)}
        />

        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Title, Reason for call"
          onChange={this.onTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }

};

export default ServiceAgreement; 